function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6968 25C33.8536 25 28.2881 30.5655 28.2881 37.4087C28.2881 39.7996 28.9696 42.128 30.2644 44.127C31.474 46.0011 33.1607 47.5118 35.1541 48.5113V49.3575H34.3874C34.1602 49.3575 33.9728 49.5386 33.9728 49.7715C33.9728 49.9986 34.1602 50.1809 34.3874 50.1809H35.1541V57.6034C35.1541 57.8306 35.3358 58.018 35.563 58.018H37.7835V59.5854C37.7835 59.8183 37.9709 60 38.198 60H43.1956C43.4279 60 43.6096 59.8183 43.6096 59.5854V58.018H45.8301C46.0573 58.018 46.2441 57.8363 46.2441 57.6034V55.417H47.0057C47.2379 55.417 47.4197 55.2353 47.4197 55.0081C47.4197 54.7753 47.2379 54.5935 47.0057 54.5935H46.2452V52.8728H47.0068C47.2391 52.8728 47.4208 52.6916 47.4208 52.4639C47.4208 52.2362 47.2391 52.0499 47.0068 52.0499H46.2452V50.1815H47.0068C47.2391 50.1815 47.4208 49.9941 47.4208 49.7669C47.4208 49.5398 47.2391 49.3529 47.0068 49.3529H46.2452V48.5067C48.2329 47.5129 49.9202 46.0023 51.1298 44.1282C52.4246 42.1235 53.1055 39.8007 53.1055 37.4099C53.1055 30.5655 47.5401 25 40.6968 25ZM45.4161 52.0493H39.5667C39.3338 52.0493 39.1521 52.2362 39.1521 52.4633C39.1521 52.6905 39.3338 52.8779 39.5667 52.8779H45.4161V54.593H39.5667C39.3338 54.593 39.1521 54.7747 39.1521 55.0075C39.1521 55.2341 39.3338 55.4215 39.5667 55.4215H45.4161V57.1934H43.2013C43.1956 57.1934 43.1956 57.1934 43.1956 57.1934H35.9775V50.1809H45.4161V52.0493Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1721 29.2617L27.8105 30.2078C27.8747 30.2447 27.9462 30.2634 28.0166 30.2634C28.1592 30.2634 28.2978 30.189 28.3739 30.0573C28.488 29.8585 28.4204 29.6069 28.2234 29.4928L26.5844 28.5467C26.3879 28.4325 26.134 28.5001 26.0216 28.6989C25.9069 28.8948 25.9745 29.1469 26.1721 29.2617Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4674 37.1712C26.4674 36.9435 26.2829 36.7578 26.0546 36.7578H24.1634C23.9351 36.7578 23.75 36.9424 23.75 37.1712C23.75 37.399 23.9346 37.5835 24.1634 37.5835H26.0546C26.2829 37.5835 26.4674 37.3995 26.4674 37.1712Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8106 44.1344L26.1722 45.0788C25.9746 45.1929 25.907 45.4457 26.0206 45.6439C26.0972 45.7756 26.2352 45.85 26.3778 45.85C26.4482 45.85 26.5197 45.833 26.5833 45.7944L28.2235 44.8482C28.4205 44.7341 28.4881 44.4814 28.374 44.2849C28.2598 44.0889 28.0082 44.0202 27.8106 44.1344Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M55.2205 45.0804L53.5832 44.1343C53.3844 44.0202 53.1329 44.0889 53.0187 44.2865C52.9046 44.4853 52.9733 44.7369 53.1709 44.851L54.8093 45.796C54.8746 45.8329 54.9445 45.8517 55.0143 45.8517C55.1574 45.8517 55.296 45.7761 55.3727 45.6449C55.4868 45.4467 55.4204 45.1946 55.2205 45.0804Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M57.2291 36.7585H55.3403C55.1131 36.7585 54.9263 36.9431 54.9263 37.172C54.9263 37.3997 55.1114 37.5843 55.3403 37.5843H57.2291C57.4563 37.5843 57.6431 37.4014 57.6431 37.172C57.6431 36.9437 57.4569 36.7585 57.2291 36.7585Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M53.0209 30.0562C53.0953 30.1879 53.2361 30.2623 53.377 30.2623C53.4468 30.2623 53.5189 30.2441 53.5831 30.2066L55.2204 29.2605C55.4203 29.1464 55.4867 28.8936 55.3726 28.6972C55.2584 28.4984 55.0057 28.4308 54.8092 28.545L53.1708 29.4911C52.9732 29.6058 52.9067 29.8574 53.0209 30.0562Z",
  fill: "black"
});

var SvgHealthyThinking = function SvgHealthyThinking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9268L40.8156 15.9189L40.7979 15.9207L40.7917 15.9251L40.8058 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9003 15.932L80.7501 18.4192V13.427L41.0246 15.9053L40.9003 15.932Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7838 15.9254L40.7874 15.9209L40.7767 15.9218L40.775 15.9245L40.7838 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9224H40.7526V15.9243H40.7579V15.9224Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8505 15.9293L40.8957 15.9133L40.8407 15.9167L40.8202 15.9274L40.8505 15.9293Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7676 15.9199H40.765V15.927H40.7676V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4787V29.8308L40.75 15.9641L0.75 24.4787Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9642L40.9002 15.9322L40.8505 15.9297L40.75 15.9642Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9057L80.75 7.44978V2.09863L40.8958 15.9138L41.0244 15.9057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9136L40.8503 15.9296L40.9 15.9322L41.0244 15.9055L40.8958 15.9136Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8945 31.6588L40.7499 15.9641L10.5712 31.6588H17.8945Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8408 15.917L80.7501 -4.83837V-11.5034L40.8158 15.919L40.8408 15.917Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.9268L40.75 15.9641L40.8202 15.9276L40.8059 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9277L40.8407 15.917L40.816 15.9189L40.8062 15.9268L40.8202 15.9277Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3684 31.6588L40.7499 15.9641L23.7343 31.6588H27.3684Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7979 15.9204L80.7499 -20.9296V-25.6394H76.2223L40.7872 15.9204H40.7979Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.925L40.75 15.9641L40.7918 15.925H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7919 15.9254L40.7981 15.9209H40.7874L40.7838 15.9254H40.7919Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2055 31.6588L40.7501 15.9641L30.7867 31.6588H33.2055Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7767 15.9213L67.1588 -25.6394H60.7524L40.7697 15.9213H40.7767Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9243L40.75 15.9642L40.775 15.9243H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7748 15.9199H40.7714V15.927H40.7748V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6588L40.75 15.9641L35.7202 31.6588H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7633 15.9222L54.0836 -25.6394H48.9367L40.7579 15.9222H40.7633Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9243L40.75 15.9642L40.7632 15.9243H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.657 31.6588L40.7499 15.9641L39.8439 31.6588H41.657Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7526 15.9241L40.7501 15.9232L40.7526 15.9222L43.1503 -25.6394H38.3507L40.7501 15.964L40.7526 15.9241Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9234L40.7524 15.9242V15.9224L40.75 15.9234Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6588L40.75 15.9641L43.8386 31.6588H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5642 -25.6394H27.4174L40.7501 15.964L32.5642 -25.6394Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6588L40.75 15.9641L48.2954 31.6588H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7495 -25.6394H14.3412L40.7499 15.964L20.7495 -25.6394Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6588L40.75 15.9641L54.1307 31.6588H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.6392H0.75V-20.9302L40.75 15.9642L5.27774 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6588L40.75 15.9641L63.6055 31.6588H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5034V-4.83837L40.75 15.9642L0.75 -11.5034Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.8308V24.4787L40.75 15.9641L80.75 29.8308Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.09766V7.44968L40.75 15.9642L0.75 2.09766Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), _ref5, /*#__PURE__*/React.createElement("path", {
    d: "M45.5585 38.3629L40.7298 44.5047L35.9011 38.3629H38.4143C38.5555 38.3629 38.7108 38.2641 38.7673 38.1511L39.5297 36.6828C39.5862 36.5839 39.7274 36.5839 39.7839 36.6828L41.6758 40.3255C41.7323 40.4243 41.817 40.4808 41.9158 40.4808C42.0147 40.4808 42.0994 40.4243 42.1559 40.3255L43.116 38.4618C43.1442 38.4053 43.2007 38.3771 43.2713 38.3771L45.5585 38.3629Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3015 37.9393C38.358 37.9393 38.4285 37.9111 38.4568 37.8546L39.4169 35.9909C39.4734 35.8921 39.5581 35.8356 39.6569 35.8356C39.7557 35.8356 39.8405 35.8921 39.8969 35.9909L41.7889 39.6336C41.8454 39.7324 41.9865 39.7324 42.043 39.6336L42.8054 38.1652C42.8619 38.0523 43.0314 37.9534 43.1584 37.9534H45.8975L46.2364 37.5158C46.8011 36.838 47.1118 35.9485 47.0129 34.9743C46.8576 33.28 45.4739 31.9246 43.7797 31.8117C42.5372 31.727 41.4077 32.3058 40.73 33.2236C40.0522 32.3058 38.9227 31.727 37.6802 31.8117C35.986 31.9246 34.5882 33.28 34.4329 34.9743C34.3481 35.9344 34.6588 36.8239 35.2235 37.5016L35.5624 37.9393H38.3015Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthyThinking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/healthy-thinking.1035bde8.svg";
export { ForwardRef as ReactComponent };